import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import UseKillSplineLogo from './components/UseKillSplineLogo';
import LandingPageWrapper from './components/LandingPageWrapper';
import Dashboard from './pages/Dashboard';
import ComingSoonPage from './pages/LandingPage/ComingSoon';
import StatsAI from './pages/LandingPage/StatsAI';

// Main Public Pages
import About from './pages/LandingPage/About';
import Services from './pages/LandingPage/Services';
import Solutions from './pages/LandingPage/Solutions';
import CaseStudies from './pages/LandingPage/CaseStudies';
import Blog from './pages/blog/Blog';
import BlogPost from './pages/blog/BlogPost';

// Trust & Growth Pages
import Testimonials from './pages/testimonials/Testimonials';
import TestimonialDetail from './pages/testimonials/TestimonialDetail';
import Technology from './pages/LandingPage/Technology';
import Vision30Maroc from './pages/LandingPage/Vision30Maroc';

// Conversion Pages
import Contact from './pages/LandingPage/Contact';
import BookConsultation from './pages/LandingPage/BookConsultation';
import Careers from './pages/LandingPage/Careers';

// Legal Pages
import PrivacyPolicy from './pages/LandingPage/PrivacyPolicy';
import TermsOfService from './pages/LandingPage/TermsOfService';

// Business Pages
import BusinessOverview from './pages/business/Overview';
import SalesPipeline from './pages/business/SalesPipeline';
import Finance from './pages/business/Finance';
import BusinessProjects from './pages/business/Projects';

// Team Pages
import TeamDirectory from './pages/team/Directory';
import TeamTasks from './pages/team/Tasks';
import TeamPerformance from './pages/team/Performance';
import TeamRecruitment from './pages/team/Recruitment';

// Tech Pages
import TechCode from './pages/tech/Code';
import TechDeployments from './pages/tech/Deployments';
import TechMonitor from './pages/tech/Monitor';
import TechBugs from './pages/tech/Bugs';

// Knowledge Pages
import KnowledgeDocs from './pages/knowledge/Docs';
import KnowledgeLessons from './pages/knowledge/Lessons';
import KnowledgePractices from './pages/knowledge/Practices';
import KnowledgeResearch from './pages/knowledge/Research';

// Owner Pages
import OwnerEquity from './pages/owner/Equity';
import OwnerVault from './pages/owner/Vault';
import OwnerBoard from './pages/owner/Board';
import OwnerAI from './pages/owner/AI';

// Utility Pages
import Notifications from './pages/utilities/Notifications';
import Settings from './pages/utilities/Settings';
import Profile from './pages/utilities/Profile';

function App() {
  return (
    <Router>
      <UseKillSplineLogo />
      <Routes>
        {/* Landing Pages - Always Dark Theme */}
        <Route path="/" element={
          <LandingPageWrapper>
            <StatsAI />
          </LandingPageWrapper>
        } />
        <Route path="/coming-soon" element={
          <LandingPageWrapper>
            <ComingSoonPage />
          </LandingPageWrapper>
        } />
        
        {/* Main Public Pages - Always Dark Theme */}
        <Route path="/about" element={
          <LandingPageWrapper>
            <About />
          </LandingPageWrapper>
        } />
        <Route path="/services" element={
          <LandingPageWrapper>
            <Services />
          </LandingPageWrapper>
        } />
        <Route path="/solutions" element={
          <LandingPageWrapper>
            <Solutions />
          </LandingPageWrapper>
        } />
        <Route path="/case-studies" element={
          <LandingPageWrapper>
            <CaseStudies />
          </LandingPageWrapper>
        } />
        <Route path="/blog" element={
          <LandingPageWrapper>
            <Blog />
          </LandingPageWrapper>
        } />
        <Route path="/blog/:id" element={
          <LandingPageWrapper>
            <BlogPost />
          </LandingPageWrapper>
        } />
        
        {/* Trust & Growth Pages - Always Dark Theme */}
        <Route path="/testimonials" element={
          <LandingPageWrapper>
            <Testimonials />
          </LandingPageWrapper>
        } />
        <Route path="/testimonials/:id" element={
          <LandingPageWrapper>
            <TestimonialDetail />
          </LandingPageWrapper>
        } />
        <Route path="/technology" element={
          <LandingPageWrapper>
            <Technology />
          </LandingPageWrapper>
        } />
        <Route path="/vision-2030" element={
          <LandingPageWrapper>
            <Vision30Maroc />
          </LandingPageWrapper>
        } />
        
        {/* Conversion Pages - Always Dark Theme */}
        <Route path="/contact" element={
          <LandingPageWrapper>
            <Contact />
          </LandingPageWrapper>
        } />
        <Route path="/book-consultation" element={
          <LandingPageWrapper>
            <BookConsultation />
          </LandingPageWrapper>
        } />
        <Route path="/careers" element={
          <LandingPageWrapper>
            <Careers />
          </LandingPageWrapper>
        } />
        
        {/* Legal Pages - Always Dark Theme */}
        <Route path="/privacy-policy" element={
          <LandingPageWrapper>
            <PrivacyPolicy />
          </LandingPageWrapper>
        } />
        <Route path="/terms-of-service" element={
          <LandingPageWrapper>
            <TermsOfService />
          </LandingPageWrapper>
        } />
        
        {/* Auth Pages - BLOCKED for landing page only mode */}
        <Route path="/login" element={
          <LandingPageWrapper>
            <div className="min-h-screen bg-background flex items-center justify-center">
              <div className="text-center space-y-6 max-w-md mx-auto px-4">
                <h1 className="text-4xl font-bold text-foreground">Authentication Disabled</h1>
                <p className="text-xl text-muted-foreground">
                  Login and registration are currently disabled. This is a landing page only mode.
                </p>
                <div className="space-y-4">
                  <a href="/" className="inline-block">
                    <button className="px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors">
                      Return to Homepage
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </LandingPageWrapper>
        } />
        <Route path="/register" element={
          <LandingPageWrapper>
            <div className="min-h-screen bg-background flex items-center justify-center">
              <div className="text-center space-y-6 max-w-md mx-auto px-4">
                <h1 className="text-4xl font-bold text-foreground">Registration Disabled</h1>
                <p className="text-xl text-muted-foreground">
                  Registration is currently disabled. This is a landing page only mode.
                </p>
                <div className="space-y-4">
                  <a href="/" className="inline-block">
                    <button className="px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors">
                      Return to Homepage
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </LandingPageWrapper>
        } />
        <Route path="/verify-email" element={
          <LandingPageWrapper>
            <div className="min-h-screen bg-background flex items-center justify-center">
              <div className="text-center space-y-6 max-w-md mx-auto px-4">
                <h1 className="text-4xl font-bold text-foreground">Email Verification Disabled</h1>
                <p className="text-xl text-muted-foreground">
                  Email verification is currently disabled. This is a landing page only mode.
                </p>
                <div className="space-y-4">
                  <a href="/" className="inline-block">
                    <button className="px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors">
                      Return to Homepage
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </LandingPageWrapper>
        } />
        
        {/* Dashboard and App Routes - BLOCKED for landing page only mode */}
        <Route path="/dashboard" element={
          <LandingPageWrapper>
            <div className="min-h-screen bg-background flex items-center justify-center">
              <div className="text-center space-y-6 max-w-md mx-auto px-4">
                <h1 className="text-4xl font-bold text-foreground">Dashboard Disabled</h1>
                <p className="text-xl text-muted-foreground">
                  Dashboard access is currently disabled. This is a landing page only mode.
                </p>
                <div className="space-y-4">
                  <a href="/" className="inline-block">
                    <button className="px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors">
                      Return to Homepage
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </LandingPageWrapper>
        } />
        
        {/* Protected routes with layout - BLOCKED for landing page only mode */}
        <Route path="/app" element={
          <LandingPageWrapper>
            <div className="min-h-screen bg-background flex items-center justify-center">
              <div className="text-center space-y-6 max-w-md mx-auto px-4">
                <h1 className="text-4xl font-bold text-foreground">App Access Disabled</h1>
                <p className="text-xl text-muted-foreground">
                  App access is currently disabled. This is a landing page only mode.
                </p>
                <div className="space-y-4">
                  <a href="/" className="inline-block">
                    <button className="px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors">
                      Return to Homepage
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </LandingPageWrapper>
        }>
          <Route index element={<Navigate to="/app/business/overview" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          
          {/* Business Routes */}
          <Route path="business/overview" element={<BusinessOverview />} />
          <Route path="business/sales" element={<SalesPipeline />} />
          <Route path="business/finance" element={<Finance />} />
          <Route path="business/projects" element={<BusinessProjects />} />
          
          {/* Team Routes */}
          <Route path="team/directory" element={<TeamDirectory />} />
          <Route path="team/tasks" element={<TeamTasks />} />
          <Route path="team/performance" element={<TeamPerformance />} />
          <Route path="team/recruitment" element={<TeamRecruitment />} />
          
          {/* Tech Routes */}
          <Route path="tech/code" element={<TechCode />} />
          <Route path="tech/deployments" element={<TechDeployments />} />
          <Route path="tech/monitor" element={<TechMonitor />} />
          <Route path="tech/bugs" element={<TechBugs />} />
          
          {/* Knowledge Routes */}
          <Route path="knowledge/docs" element={<KnowledgeDocs />} />
          <Route path="knowledge/lessons" element={<KnowledgeLessons />} />
          <Route path="knowledge/practices" element={<KnowledgePractices />} />
          <Route path="knowledge/research" element={<KnowledgeResearch />} />
          
          {/* Owner Routes */}
          <Route path="owner/equity" element={<OwnerEquity />} />
          <Route path="owner/vault" element={<OwnerVault />} />
          <Route path="owner/board" element={<OwnerBoard />} />
          <Route path="owner/ai" element={<OwnerAI />} />
          
          {/* Utility Routes */}
          <Route path="utilities/notifications" element={<Notifications />} />
          <Route path="utilities/settings" element={<Settings />} />
          <Route path="utilities/profile" element={<Profile />} />
        </Route>
        
        {/* Catch all route - redirect to homepage */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
